// ─── Workshop Truck Availability Tracker ───
// SkeletonCard – Animated loading placeholder cards
// IASL Technical Academy / Lafarge Driving Institute, Nigeria

interface SkeletonCardProps {
  count?: number
}

function SingleSkeleton() {
  return (
    <div className="bg-white rounded-xl p-5 animate-pulse">
      {/* Icon + title row */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 bg-gray-200 rounded-full" />
        <div className="h-4 bg-gray-200 rounded w-24" />
      </div>
      {/* Large number */}
      <div className="h-8 bg-gray-200 rounded w-20 mb-2" />
      {/* Subtitle */}
      <div className="h-3 bg-gray-200 rounded w-32" />
    </div>
  )
}

export default function SkeletonCard({ count = 1 }: SkeletonCardProps) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <SingleSkeleton key={i} />
      ))}
    </>
  )
}
